import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/ReviewsPage/reviewsPage.js");
